import React from "react";
import { Loader2 } from "lucide-react";

// Optional variant: bouncing dots
export default function Loading({
  message = "Loading...",
  fullscreen = false,
  small = false,
  variant = "spinner", // "spinner" | "dots"
}) {
  const Wrapper = fullscreen ? "div" : React.Fragment;
  const wrapperProps = fullscreen
    ? {
        className:
          "fixed inset-0 z-50 flex flex-col items-center justify-center bg-white/70 backdrop-blur-sm dark:bg-navy-900/80",
      }
    : {};

  if (variant === "dots") {
    return (
      <Wrapper {...wrapperProps}>
        <div className="flex items-center space-x-1">
          {[...Array(3)].map((_, i) => (
            <span
              key={i}
              className="h-2 w-2 animate-bounce rounded-full bg-orange-500"
              style={{ animationDelay: `${i * 0.15}s` }}
            />
          ))}
          <span className="ml-3 text-sm text-gray-600 dark:text-gray-300">
            {/* {message} */}
          </span>
        </div>
      </Wrapper>
    );
  }

  // default spinner
  return (
    <Wrapper {...wrapperProps}>
      <div
        className={`flex items-center justify-center ${
          small ? "space-x-2" : "space-x-3"
        } text-gray-600 dark:text-gray-300`}
      >
        <Loader2
          className={`animate-spin ${
            small ? "h-4 w-4" : "h-6 w-6"
          } text-orange-500`}
        />
        {!small && <span className="font-medium">{message}</span>}
      </div>
    </Wrapper>
  );
}
